// Google Analytics utility functions for Volepse.me
import { CookieConsent } from './cookieConsent';

/**
 * Check if analytics is available and user has consented
 */
const isAnalyticsAvailable = () => {
  return typeof window !== 'undefined' &&
         window.gtag &&
         CookieConsent.hasConsent() === true;
};

/**
 * Track page view
 * @param {string} pagePath - The page path to track
 * @param {string} pageTitle - The page title
 */
export const trackPageView = (pagePath, pageTitle) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'page_view', {
      page_path: pagePath,
      page_title: pageTitle,
    });
  }
};

/**
 * Track custom event
 * @param {string} eventName - Name of the event
 * @param {object} eventParams - Additional parameters
 */
export const trackEvent = (eventName, eventParams = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
};



/**
 * Track pricing tier selection
 * @param {number} tier - Tier number (1, 2, or 3)
 * @param {string} tierName - Name of the tier
 * @param {number} price - Price of the tier
 */
export const trackPricingSelection = (tier, tierName, price) => {
  trackEvent('select_pricing_tier', {
    tier: tier,
    tier_name: tierName,
    price: price,
    currency: 'EUR',
    event_category: 'pricing',
  });
};

/**
 * Track waitlist signup
 * @param {string} source - Where the signup came from (modal, form, etc.)
 */
export const trackWaitlistSignup = (source = 'form') => {
  trackEvent('waitlist_signup', {
    event_category: 'conversion',
    event_label: source,
    value: 1,
  });
};

/**
 * Track modal open/close
 * @param {string} action - 'open' or 'close'
 */
export const trackModal = (action) => {
  trackEvent(`modal_${action}`, {
    event_category: 'engagement',
    event_label: 'Email Modal',
  });
};

/**
 * Track CTA button clicks
 * @param {string} buttonName - Name/label of the button
 * @param {string} destination - Where the button leads
 */
export const trackCTAClick = (buttonName, destination = '') => {
  trackEvent('cta_click', {
    button_name: buttonName,
    destination: destination,
    event_category: 'engagement',
  });
};
